export const smsDashboardTemplates = [
  {
    label: '"AS" Meaning A600N - English',
    value: `The icon "AS" is a symbol of arteriosclerosis, please note this is not an assessment. However, you should discuss with your physician on your next visit.`,
  },
  {
    label: '"AS" Meaning A600N - Spanish',
    value: `El icono "AS" es un símbolo de arteriosclerosis, tenga en cuenta que esto no es una evaluación. Sin embargo, debe hablar con su médico en su próxima visita.`,
  },
  {
    label: 'A600N decimals - English',
    value: `Please perform the following steps to place the readings back to normal.
1. Make sure the device is off.
2. Press & Hold down on the Green START/STOP button until you see a 0 and mmHg underneath.
3. Turn off the monitor by pressing on the start/stop button. To make sure the readings are back to normal, press on the memory button once or take a blood pressure reading.`,
  },
  {
    label: 'A600N decimals - Spanish',
    value: `Realice los siguientes pasos para que el dispositivo le muestre las lecturas en las unidades deseadas.
1. Asegúrese de que el dispositivo esté apagado.
2. Mantenga presionado el botón verde Start/Stop hasta que vea 0 y mmHg debajo.
3. Apague el monitor presionando el botón de Start/Stop.
Finalmente, presione el botón de memoria una vez o tome una lectura de presión arterial.`,
  },

  {
    label: 'A600N Test Readings - English',
    value: `Hi {first_name}, we're doing a quick check to make sure your blood pressure monitor is sending readings properly.  Would you mind taking three consecutive blood pressure readings?  After each reading, if you could just let me know the numbers, and allow the monitor to turn off on its own after each reading. That will help us confirm everything is working as expected.`,
  },
  {
    label: 'A600N Test Readings - Spanish',
    value: `Hola {first_name}, estamos haciendo una verificación rápida para asegurarnos de que su monitor de presión arterial esté enviando lecturas correctamente. ¿Le importaría tomar tres lecturas consecutivas de presión arterial? Después de cada lectura, si pudiera dejarme saber los números, y permita que el monitor se apague solo después de cada lectura. Eso nos ayudará a confirmar que todo está funcionando como se esperaba.`,
  },
  {
    label: 'Accuhealth Response - English',
    value: `Hello, this is Evelyn from Accuhealth. How may we assist you today?`,
  },
  {
    label: 'Accuhealth response - Spanish',
    value: `Hola, soy su agente de Accuhealth. ¿Cómo puedo ayudarle hoy?`,
  },
  {
    label: 'Automation template - English',
    value: `We apologize for any confusion caused by the recent health reading reminder you received. Sometimes readings transmit later in the day, or there may not have been a reading available this morning when the report was generated.

You can disregard the reminder if you've already taken your readings. If you receive one of these reminders and are unsure if we've received your reading, please don't hesitate to reach out to us. We'll be happy to confirm for you.

We appreciate you taking your daily readings!
`,
  },
  {
    label: 'Automation template - Spanish',
    value: `Nos disculpamos por cualquier confusión causada por el reciente recordatorio de lectura de salud que recibió. A veces, las lecturas se transmiten más tarde en el día o es posible que no haya habido una lectura disponible esta mañana cuando se generó el informe.

Puede ignorar el recordatorio si ya tomó sus lecturas. Si recibe uno de estos recordatorios y no está seguro de que su lcetura haya sido transmitida correctmente, no dude en comunicarse con nosotros. Estaremos encantados de ayudarle.
¡Le agradecemos que tome sus lecturas diarias!
`,
  },
  {
    label: 'Billing Concern - English',
    value: `Accuhealth does not bill Medicare, we partner with your doctor to provide this great service to you. I encourage you to discuss with your insurance carrier to obtain more information.`,
  },
  {
    label: 'Billing Concern - Spanish',
    value: `Accuhealth no factura a Medicare, trabajamos en colaboración con su médico para brindarle este excelente servicio. Le invitamos a que contacte a su proveedor de seguro médico para obtener más información.`,
  },
  {
    label: 'Bingo - English',
    value: `{bingo_number} 

Good luck and a friendly reminder to continue taking your daily health readings. Also, is there anything else we can assist you with such as scheduling a follow-up with your referring provider? `,
  },
  {
    label: 'Bingo - Spanish',
    value: `{bingo_number} 

Buena suerte! Recuerde continuar tomando sus lecturas diarias ¿Hay algo adicional en lo que podamos ayudarle, cómo programar un seguimiento con su doctor?`,
  },
  {
    label: 'BP Inaccurate Readings - English',
    value: `Please check the following items that may be interfering with your readings:
1. Is the size of your cuff the right size? You should be able to slide two fingers on the top and bottom of the cuff.
2. Are you positioning your cuff properly? Remember to place it 2 inches above your elbow.
3. The gray rubber tubing should come out the bottom of the cuff and be in line with the palm of your hand.
4. Remove your cuff and squeeze out any air it may contain and repeat the reading.
5. Once you have performed these tests repeat your reading, if you still believe your device is giving you inaccurate readings, take your device to your doctor's office for comparison.
      `,
  },
  {
    label: 'BP Inaccurate Readings - Spanish',
    value: `Por favor revisemos los siguientes aspectos que pudieran estar interfiriendo en sus lecturas:
1. ¿La talla de su brazalete es la adecuada? Usted debe poder deslizar dos dedos en la parte superior e inferior del brazalete.
2. ¿Está colocando su brazalete adecuadamente? Recuerde que debe situarlo 2 pulgadas por encima de su codo.
3. El tubo gris de goma debe salir por la parte inferior del brazalete y alineado con la palma de su mano.
4. Retire su brazalete y exprima el aire que pueda contener y repita la lectura.
5. Una vez realizadas estas pruebas repita su lectura, si aún cree que su dispositivo le está dando lecturas inexactas, lleve su dispositivo al consultorio de su médico para que lo comparen.`,
  },
  {
    label: 'Condolences - English',
    value: `Our deepest condolences to you and your family, we want to extend our sympathy for such a sensitive loss. May the pain and sadness in your heart be lightened by the affection and love of those around you. Receive our condolences.`,
  },
  {
    label: 'Condolences - Spanish',
    value: `Nuestro más sentido pésame para usted y su familia, queremos extender nuestra solidaridad ante tan sensible pérdida. Que el dolor y tristeza que siente su corazón se vea aligerada por el cariño y amor de aquellos que le rodean. Reciba nuestras condolencias.`,
  },
  {
    label: 'Consumable Order Placed - English',
    value: `Thank you, your order has been placed, you will receive your consumables in a few days.`,
  },
  {
    label: 'Consumable Order Placed - Spanish',
    value: `Gracias, su pedido ha sido realizado, en unos días recibirá sus consumibles.`,
  },
  {
    label: 'Consumable order/Replacement placed - Updated version - English',
    value: `Thanks for confirming your address! Your order is placed and on its way. You can expect it within a few days. Disregard any friendly reminders you might receive. We hope you have a great day!`,
  },
  {
    label: 'Consumable order/Replacement placed - Updated version - Spanish',
    value: `¡Gracias por confirmar su dirección! Su pedido está realizado y en camino. Puede esperarlo dentro de unos días. Mientras tanto, ignore cualquier recordatorio amistoso que pueda recibir. ¡Esperamos que tenga un gran día!`,
  },
  {
    label: 'Contact availability - English',
    value: `To best suit your schedule, is there a preferred day or time during the week or weekend for us to reach you? We offer weekday support from 8am to 7pm central time and weekends from 8am to 5pm central time. Our nursing staff is available 24/7 for urgent concerns. This information will be added to your profile for future reference.`,
  },
  {
    label: 'Contact availability - Spanish',
    value: `Para adaptarnos mejor a su horario, ¿hay algún día u hora durante la semana o el fin de semana que usted prefiera para que podamos comunicarnos con usted? Ofrecemos soporte entre semana de 8 a.m. a 7 p.m. hora central y los fines de semana de 8 a. m. a 5 p. m. hora central. Nuestro personal de enfermería está disponible las 24 horas del día, los 7 días de la semana para inquietudes urgentes. Esta información se agregará a su perfil para referencia futura.`,
  },
  {
    label: 'Contact number - English',
    value: `Hi {first_name},

We're here to help if you have any questions! You can reach us by phone at 1-888-407-4108 or by text at 90105.

Have a great day!`,
  },
  {
    label: 'Contact number - Spanish',
    value: `Hola {first_name},

¡Accuhealth siempre está aquí para ayudarle si tiene alguna pregunta! Puede comunicarse con nosotros por teléfono al 1-888-407-4108 o por mensaje de texto al 90105.

¡Qué tenga un lindo día!`,
  },
  {
    label: 'Critical Reading Received - English',
    value: `Thank you so much! We have received your readings, we would like to take a moment of your time to thank you for taking your readings consecutively. How are you feeling today? Would you like to talk to a nurse?`,
  },
  {
    label: 'Critical Reading Received - Spanish',
    value: `Muchas gracias! Hemos recibido sus lecturas, queremos tomar un momento de su tiempo para agradecerle por tomar sus lecturas consecutivamente. ¿Cómo se siente hoy? ¿Le gustaría hablar con una enfermera?`,
  },
  {
    label: 'Critical reading received - Updated version - English',
    value: `Thank you for taking your readings consistently. We've received your readings, and one of them fell outside the expected range. This doesn't necessarily mean there's a problem, but we want to follow up to ensure everything is okay. A nurse will be calling you shortly to discuss the reading in more detail.`,
  },
  {
    label: 'Critical reading received - Updated version - Spanish',
    value: `Gracias por tomar sus lecturas consistentemente. Hemos estado recibiéndolas y una de ellas estuvo fuera del rango esperado. Esto no significa necesariamente que haya un problema, pero queremos hacer un seguimiento para asegurarnos de que todo esté bien. Una enfermera lo llamará en breve para analizar la lectura con más detalle.`,
  },
  {
    label: 'Cuff sizes - English',
    value: `We are happy to send you a bracelet that fits your arm properly, we have the following sizes available, please let us know which size you require:
Small = 15-22 cm or 6-9 inches.
Adult = 22-42 cm or 9 - 17 inches
XL = 38-55 cm or 15-22 inches`,
  },
  {
    label: 'Cuff sizes - Spanish',
    value: `Con gusto podemos enviarle un brazalete que se ajuste adecuadamente a su brazo, tenemos las siguientes tallas disponibles, por favor háganos saber cuál es la que requiere:
Pequeño = 15-22 cm o 6-9 pulgadas
Adulto = 22-42 cm o 9 -17 pulgadas
XL = 38-55 cm o 15-22 pulgadas
`,
  },
  {
    label: 'Discharge questions - English',
    value: `We are very sorry to hear that you will no longer be a part of Accuhealth. To confirm cancellation of service and to help us improve, we would appreciate it if you would take a moment to answer the following questions:

1. What is the main concern with your device or services?

2. How can we best help you or other patients in the future?

3. Is there anything we can do so we can continue to monitor your health?`,
  },
  {
    label: 'Discharge questions - Spanish',
    value: `Lamentamos mucho que ya no será parte de Accuhealth. Para confirmar la cancelación del servicio y para ayudarnos a mejorar, le agradeceríamos que dedicara un momento a contestar las siguientes preguntas:

1. ¿Cuál es la principal preocupación con su dispositivo o servicios?

2. ¿Cómo podemos ayudarle mejor a usted o a otros pacientes en el futuro?

3. ¿Hay algo que pueda hacer para que podamos seguir monitoreando su salud?
      `,
  },
  {
    label: 'Glucose Test Readings - English',
    value: `Great! Let's do a quick test on your glucometer to see if it transmits readings or to check the strips (without control solution).  We'll take 3 readings in a row.

Grab a test strip and insert it into the top of the meter. Make sure the blue side is facing up and the white arrow is pointing down.
We'll use a sugary liquid instead of blood. You can use something like orange juice, soda with sugar, or even water with sugar mixed in.
Put a tiny drop of the liquid on the test strip. The meter should give you a "HI" reading.
By using a sugary liquid, we expect the meter to read "HI" because the sugar level will be very high. This helps us see if the meter and strips are working properly.

Discard that strip and use a new one for your actual blood sugar test.

Remember, this is just a test.  For accurate blood sugar readings, you'll always need to use a fresh strip and a blood sample.`,
  },
  {
    label: 'Glucose Test Readings - Spanish',
    value: `¡Excelente! Hagamos una prueba rápida en su glucómetro para ver si transmite lecturas o para revisar las tiras (sin solución de control). Tomaremos 3 lecturas seguidas.

Tome una tira reactiva e insértela en la parte superior del medidor. Asegúrese de que el lado azul esté hacia arriba y la flecha blanca apunte hacia abajo.
Usaremos un líquido azucarado en lugar de sangre; puede usar algo como jugo de naranja, refresco con azúcar o incluso agua con azúcar mezclada.
Coloque una pequeña gota de líquido en la tira reactiva. El medidor debería dar una lectura "HI".
Al usar un líquido azucarado, esperamos que el medidor indique "HI" porque el nivel de azúcar será muy alto. Esto nos ayuda a ver si el medidor y las tiras funcionan correctamente.

Deseche esa tira y use una nueva para su prueba de azúcar en sangre real.

Recuerde, esto es sólo una prueba. Para obtener lecturas precisas de azúcar en sangre, siempre necesitará utilizar una tira nueva y una muestra de sangre.`,
  },
  {
    label: 'Information - English',
    value: `Your physician has recommended the use of this device as a preventive measure to better monitor your health. Accuhealth provides remote monitoring, so you can take your daily readings from the comfort of your home, making it easy for your doctor to receive them instantly without having to keep track on a paper or tablet. Every reading you take helps both your doctor and our nurses monitor your health and help you improve it, as well as prevent you from going to the emergency room. Would you like one of our representatives to contact you so we can answer all your questions?`,
  },
  {
    label: 'Information - Spanish',
    value: `Su médico le ha recomendado el uso de este dispositivo como medida preventiva para controlar mejor su salud. Accuhealth proporciona monitorización remota, por lo que puede tomar sus lecturas diarias desde la comodidad de su hogar, lo que facilita que su médico las reciba al instante sin tener que llevar un registro en un papel o una tableta. Cada lectura que tome ayuda tanto su doctor como a nuestras enfermeras supervisar su salud y ayudarle a mejorarla, así como evitar que acuda a urgencias. Desea que uno de nuestros representantes se ponga en contacto con usted para que pueda disipar todas sus dudas?`,
  },
  {
    label: 'No readings - Battery Related - English',
    value: `Hello {first_name}, we have not received your readings recently. Have you changed the batteries in your device, or have you allowed the device to turn itself off?`,
  },
  {
    label: 'No readings - Battery Related - Spanish',
    value: `Hola {first_name}, no hemos recibido tus lecturas recientemente ¿ha cambiado las pilas de su dispositivo o ha dejado que se apague solo?`,
  },
  {
    label: 'No Readings - Rechargeable - English',
    value: `Hello {first_name}, we have not received a recent reading. Have you charged your monitor recently and have you allowed it to turn off on its own?`,
  },
  {
    label: 'No Readings - Rechargeable - Spanish',
    value: `Hola {first_name}, no hemos recibido sus lecturas recientemente ¿ha cargado su dispositivo o ha dejado que se apague solo?`,
  },
  {
    label: 'No wifi requirements - English',
    value: `Hello. This monitor is really convenient! It doesn't need WiFi to connect, but it uses a secure cellular network to send your readings safely - that means you can use it anywhere with cell service.`,
  },
  {
    label: 'No wifi requirements - Spanish',
    value: `Hola ¡Este monitor es realmente increíble! No necesita WiFi para conectarse, utiliza una red celular para enviar sus lecturas de forma segura; eso significa que puede usarlo en cualquier lugar con señal celular.`,
  },
  {
    label: 'PAT - English',
    value: `Dear {first_name},
This is Evelyn, your Accuhealth assistant. We are trying to reach you to discuss the Remote Monitoring services that your doctor referred you to. We tried to reach you by phone, but you were not available, what is the best time to reach you, would you like us to set up an appointment with one of our agents?`,
  },
  {
    label: 'PAT - Spanish',
    value: `Estimado {first_name},
Soy Evelyn su asistente de Accuhealth. Estamos tratando de comunicarnos con usted para platicarle sobre los servicios de Monitoreo Remoto a los cuales su doctor lo refirió. Intentamos comunicarnos con usted por teléfono, pero no estaba disponible, ¿cuál es el mejor momento para comunicarnos con usted? ¿Desea que concretemos una cita con uno de nuestros agentes?`,
  },
  {
    label: 'Patient Account Request - English',
    value: `Thank you for confirming, your request is being processed, please keep an eye on your inbox. In the next 24 to 48 hours, you should receive an email from Accuhealth, which will contain a link that will direct you to your account. You will have 24 hours to open it and set up your account.`,
  },
  {
    label: 'Patient Account Request - Spanish',
    value: `Muchas gracias, su solicitud está siendo procesada, por favor esté al pendiente de su bandeja de entrada. En los próximas 24 a 48, horas usted deberá recibir un correo electrónico por parte de Accuhealth, el cual contendrá un link que lo direccionará a su cuenta. Tendrá 24 horas para abrirlo y configurar su cuenta.`,
  },
  {
    label: 'Patient in the Hospital - English',
    value: `Hello, I am so sorry to hear that. We hope you have a speedy recovery. Please disregard any further friendly reminders. If you do receive, please respond with the number "83". Thank you.`,
  },
  {
    label: 'Patient in the Hospital - Spanish',
    value: `Estimado paciente, lamentamos mucho escuchar eso. Esperamos que se recuperes pronto. En caso de que reciba algún mensaje de texto adicional, por favor responda con el número "93". Gracias.`,
  },
  {
    label: 'Reading Received - English',
    value: `Hi there! We are receiving your readings. Thank you and a friendly reminder to continue taking your daily readings. Also, is there anything else I can assist you with such as scheduling a follow-up with your referring provider?`,
  },
  {
    label: 'Reading Received - Spanish',
    value: `¡Hola! Le enviamos este mensaje para agradecerle por tomarse sus lecturas, las hemos estado recibiendo exitosamente. Por favor no olvide lo importante que es tomarlas diariamente!
      Háganos saber si necesita cualquier ayuda adicional, cómo programar una cita con tu doctor o hablar con alguna de nuestras enfermeras.`,
  },
  {
    label: 'Retention - English',
    value: `Thank you for being part of Accuhealth. Before we let you go we would love to remind you that Accuhealth provides remote monitoring, so you can take your daily readings from the comfort of your home, making it easy for your doctor to receive them instantly without having to keep track of them on paper or on a tablet. Each reading you take helps both your doctor and our nurses monitor your health and help you improve your health, as well as prevent you from going to the emergency room. If you decide you want to continue in our RPM program, you can contact us at any time.`,
  },
  {
    label: 'Retention -  Spanish',
    value: `Gracias por haber formado parte de Accuhealth. Antes de despedir, nos encantaría recordarle que la monitorización remota que proporciona Accuhealth le permite realizar sus lecturas diarias desde la comodidad de su hogar, facilitando que su médico las reciba al instante sin tener que llevar un control de las mismas en papel o en una tablet. Cada lectura que realiza ayuda tanto a su médico como a nuestras enfermeras a controlar su salud y ayudarle a mejorarla, así como a evitar que acuda a urgencias. Si decide que quiere continuar en nuestro programa, puede ponerte en contacto con nosotros en cualquier momento.`,
  },
  {
    label: 'Self Acceptance Follow Up - English',
    value: `Hi {first_name}, this is Evelyn from Accuhealth. One of our agents is trying to reach you by phone to complete your Acceptance and have your device(s) shipped out. Are you available to speak on the phone?`,
  },
  {
    label: 'Self Acceptance Follow Up - Spanish',
    value: `Hola {first_name}, soy Evelyn su asistente de Accuhealth. Uno de nuestros agentes ha estado tratando de comunicarse con usted por teléfono para completar su aceptación y enviarle su dispositivo. ¿Está disponible para hablar por atender la llamada de uno de nuestros agentes?`,
  },
  {
    label: 'Sick patients- Who do not want to take readings - English',
    value: `Hello, I am sorry to hear that. We hope you have a speedy recovery. Friendly reminder why it is important to continue taking your daily health readings. Taking your daily readings helps your physician oversee your health and how your health can be improved. Providing your daily readings can also prevent you from going to the ER. Please let us know if you have any questions, get well soon!`,
  },
  {
    label: 'Sick patients- Who do not want to take readings - Spanish',
    value: `Hola, lamento escuchar eso. Esperamos que tenga una pronta recuperación.
      Recuerde que cada lectura que tome ayuda tanto su doctor como a nuestras enfermeras supervisar su salud y ayudarle a mejorarla, así como evitar que acuda a urgencias. Por favor, háganos saber si tiene alguna pregunta, ¡que se recupere pronto!`,
  },
  {
    label: 'Test Mode - English (U807/BP01)',
    value: `Okay let's try to do a very simple reset. Here are the steps: 

1. Turn off the device.
2. Press and Hold the Start/Stop button until the device displays all segments.
3. Press the MEM, SET, MEM keys in sequence, when holding the Start/Stop Button.
4. Let go of the Start/Stop Button and the device will display a dotted line on the top right corner of the screen.
5. Then, press the MEM button and the device will trigger a test reading of 100/80/60 or 255/255/199
6. The device will be in-transit until the screen displays “END”

Please let us know when done so we can verify if readings came through.
Please let me know if you receive any error messages. Also, please keep an eye out for a letter M that will show on the bottom left of the screen, please let me know what number shows under the letter M.

This will help the monitor catch a signal in your nearest cell tower.`,
  },
  {
    label: 'Test Mode - Spanish (U807/BP01)',
    value: `Bien, intentemos hacer un reinicio muy simple. Aquí están los pasos:

1. Apague el dispositivo.
2. Mantenga presionado el botón Start/Stop hasta que el dispositivo muestre todos los segmentos.
3. Presione las teclas MEM, SET, MEM en secuencia mientras mantiene presionado el botón Start/Stop
4. Suelte el botón Start/Stop y el dispositivo mostrará una línea de puntos en la esquina superior derecha de la pantalla.
5. Luego, presione el botón MEM y el dispositivo activará una lectura de prueba de 100/80/60 o 255/255/199.
6. El dispositivo estará en tránsito hasta que la pantalla muestre "END"

Háganos saber cuando haya terminado para que podamos verificar si se obtuvieron las lecturas.
Por favor, avíseme si recibe algún mensaje de error. Además, esté atento a la letra M que aparecerá en la parte inferior izquierda de la pantalla. Déjeme saber qué número aparece debajo de la letra M.

Esto ayudará al monitor a captar una señal en la torre de telefonía móvil más cercana.`,
  },
  {
    label: 'Thank you Message - English',
    value: `Thank you for letting us know. Remember, if you need to speak to a nurse you can call us at 1-888-407-4108. Have a great day!`,
  },
  {
    label: 'Thank you Message - Spanish',
    value: `Gracias por informarnos. Recuerde que si necesita hablar con alguna enfermera puede llamarnos al 1-888-407-4108. Que tenga excelente día!`,
  },
  {
    label: 'Transmission Confirmation - English',
    value: `Thank you for letting us know. Please let us know once you've taken your readings so we can verify they've been transmitted with success.`,
  },
  {
    label: 'Transmission Confirmation - Spanish',
    value: `Gracias por informarnos. Por favor, háganoslo saber una vez que haya tomado sus lecturas para que podamos verificar que se han transmitido con éxito.`,
  },
  {
    label: 'U807/BP01 decimals - English',
    value: `Please perform the following steps to place the readings back to normal.
1. Make sure the monitor is off.
2. Press on SET.
3. Then press on MEM.
4. Then turn it off by pressing on the start/stop button.
To make sure the readings are back to normal, press on MEM once or take a blood pressure reading.`,
  },
  {
    label: 'U807/BP01 decimals - Spanish',
    value: `Por favor revisemos los siguientes aspectos que pudieran estar interfiriendo en sus lecturas:
1. Asegúrese de que el monitor esté apagado.
2. Presione SET
3. Luego presione MEM
4. Apague su dispositivo presionando el botón de Start/Stop
5. Finalmente, para asegurarse de que las lecturas vuelvan a la normalidad, presione MEM una vez o tome una lectura de presión arterial.
`,
  },
  {
    label: 'Upcoming Vacation - English',
    value: `Dear Patient,

Thank you for informing us about your upcoming vacation.

To ensure your account is placed on a vacation hold while you're away, kindly reply to this message with the number "82" upon your departure.

We wish you a pleasurable and relaxing vacation.

Sincerely,

Accuhealth`,
  },
  {
    label: 'Upcoming Vacation - Spanish',
    value: `Estimado Paciente,

Gracias por informarnos sobre sus próximas vacaciones.

Para asegurarnos de que su cuenta quede suspendida durante sus vacaciones, responda a este mensaje con el número "92" cuando se vaya.

Le deseamos unas placenteras y relajantes vacaciones.

Atentamente,

Accuhealth
`,
  },
  {
    label: 'Verify Address - English',
    value: `Can you please verify your address?`,
  },
  {
    label: 'Verify Address - Spanish',
    value: `¿Podría por favor confirmar su dirección?`,
  },
  {
    label: `You're welcome - English`,
    value: `It is a pleasure to serve you, we appreciate that you continue to take your daily readings. Your health and well-being is our priority!`,
  },
  {
    label: `You're welcome - Spanish`,
    value: `Es un gusto servirle, agradecemos que siga tomándose sus lecturas diariamente. Su salud y bienestar es nuestra prioridad!`,
  },
  {
    label: 'Battery - Rechargeable - English',
    value:
      "Your device features a rechargeable battery that is non-replaceable. By charging it for 2-3 hours just once a week, you can ensure the battery lasts for an extended period. Should you experience any issues with charging, please don't hesitate to reach out, and we'll take the required actions to resolve any concerns with your monitor.",
  },
  {
    label: 'Battery - Rechargeable - Spanish',
    value:
      'Su dispositivo cuenta con una batería recargable que no es reemplazable. Con solo 2-3 horas de carga una vez a la semana, la batería está diseñada para durar mucho tiempo. Si experimenta problemas con la carga, no dude en ponerse en contacto con nosotros, y tomaremos las medidas necesarias para solucionar cualquier inconveniente con su monitor.',
  },
  {
    label: 'BG Test Readings - Connectivity - English',
    value: `We're going to run a quick test to confirm your glucometer is transmitting readings properly. This just takes a few minutes and uses a sugary liquid instead of a blood sample.
Here's what to do:

1. Insert a test strip into the top of your meter. The blue side should face up, and the white arrow should point down into the device.
2. Use a sugary liquid like orange juice, regular (non-diet) soda, or sugar water.
3. Place a small drop of the liquid on the test strip. The meter should display a "HI" reading, since the sugar level is very high. (Exact results may vary slightly depending on the liquid.)
4. Repeat this process three times in a row. This helps trigger a signal to reconnect your meter to the cell towers.
5. After each reading, leave the test strip in the meter for a few moments and watch the screen closely. You should see a message showing whether the reading was successfully transmitted or if the transmission failed.

If it says "Successful," the meter is sending data as expected.
if it says "Failed," don't worry-just move on to the next test and try again.Once you've completed all three readings, let us know how it went or if anything looked unusual!Reminder: This is just a device test. For accurate blood sugar readings, always use a fresh strip and a blood sample.
`,
  },
  {
    label: 'BG Test Readings - Connectivity - Spanish',
    value: `Vamos a realizar una prueba rápida para confirmar que tu glucómetro está transmitiendo correctamente las lecturas. Solo tomará unos minutos y puede usar un líquido azucarado en lugar de una muestra de sangre.Sigue estos pasos:

1. Inserta una tira de prueba en la parte superior del medidor. La parte azul debe estar hacia arriba y la flecha blanca debe apuntar hacia abajo, dentro del dispositivo.
2. Utiliza un líquido con azúcar como jugo de naranja, refresco regular (no dietético) o agua con azúcar.
3. Coloca una pequeña gota del líquido en la tira de prueba. El medidor debería mostrar una lectura de "HI" (alta) debido al alto contenido de azúcar. (El resultado puede variar ligeramente dependiendo del líquido.)
4. Repite este proceso tres veces seguidas. Esto ayuda a que el medidor se reconecte con las torres de señal celular.
5. Después de cada lectura, deja la tira de prueba dentro del medidor durante unos momentos y observa la pantalla con atención. Deberías ver un mensaje indicando si la lectura fue transmitida con éxito o si hubo una falla en la transmisión.

Si ves "Éxito" o "Successful", el medidor está enviando los datos correctamente.Si ves "Falla" o "Failed", no te preocupes-simplemente continúa con la siguiente prueba e inténtalo de nuevo.Cuando termines las tres lecturas, cuéntanos cómo te fue o si notaste algo fuera de lo común.Importante: Esta es solo una prueba de conexión. Para obtener lecturas precisas de glucosa en sangre, siempre usa una tira nueva y una muestra de sangre.
`,
  },
  {
    label: 'Bingo - Pending Interaction - English',
    value: `{bingo_number} 
    
Best of luck, and just a friendly reminder to keep up with your health readings. We also wanted to check in and see if you're available for your monthly interaction call. This helps us stay on track and ensure your doctor has the most up-to-date information. If you'd like to receive a call now, simply reply with '81.' If another time works better, let us know your preferred date and time.Thanks, and we look forward to speaking with you soon!`,
  },
  {
    label: 'Bingo - Pending Interaction - Spanish',
    value: `{bingo_number} 
    
Le deseamos mucha suerte y le recordamos amablemente que continúe tomando sus lecturas de salud diarias. Además, queríamos saber si está disponible para realizar su llamada de interacción mensual. Esto nos permite mantenernos al día y compartir con su médico la información más reciente.Si desea recibir una llamada ahora, responda con '91.' Si prefiere otro momento, por favor, indíquenos la fecha y hora que le resulten convenientes.¡Gracias y esperamos hablar con usted pronto!`,
  },
  {
    label: 'BP01 Alarm - Gen 1 - English',
    value: `Here's how to turn off the alarm on your blood pressure monitor:

1. Press the "SET" button six times. This will take you into the clock setting mode.
2. The screen should display "1 OF". This means you're adjusting Alarm 1.
3. You'll see "OF" or "ON" flashing. Press the "MEM" button to switch between "OF" (alarm off) and "ON" (alarm on).
4. Once you've chosen your setting, press "SET" to confirm.
5. If you have multiple alarms (Alarm 2 and Alarm 3), repeat steps 2-4 for each one.

Double-check that all the alarms (1-3) say "OF" if you want them all disabled.
`,
  },
  {
    label: 'BP01 Alarm - Gen 1 - Spanish',
    value: `Por favor siga los siguientes pasos para desactivar la alarma de su monitor de presión arterial:

1. Presione el botón "SET" seis veces. Esto lo llevará al modo de configuración del reloj.
2. La pantalla debería mostrar "1 OF". Esto significa que estás ajustando la Alarma 1.
3. Verá parpadeando en la pantalla "OF" o "ON". Presione el botón "MEM" para cambiar entre "OF" (alarma apagada) y "ON" (alarma encendida).
4. Una vez que haya elegido su configuración, presione "SET" para confirmar.
5. Si tiene varias alarmas (Alarma 2 y Alarma 3), repita los pasos 2 a 4 para cada una.

Vuelva a verificar que todas las alarmas (1-3) digan "OF" si desea que todas estén desactivadas.
`,
  },
  {
    label: 'Reading Received - Pending Interaction - English',
    value: `Hi there! We are receiving your readings. Thank you for taking them consistently! Also, we wanted to check in and see if you're available to complete your monthly interaction call. This helps us ensure that we're staying on track and providing the necessary updates to your doctor.
If you'd like to receive a callback now, please reply with "81." If you'd prefer a callback at a later time, simply let us know the date and time that works best for you.
Thank you, and we look forward to connecting with you soon!
`,
  },
  {
    label: 'Reading Received - Pending Interaction - Spanish',
    value: `¡Hola! Estamos recibiendo sus lecturas. ¡Gracias por tomarlos constantemente! Además, queríamos ver si está disponible para completar su llamada de interacción mensual. Esto nos ayuda a garantizar que mantenemos el rumbo y brindamos las actualizaciones necesarias a su médico.
Si desea recibir una devolución de llamada ahora, responda con "91". Si prefiere que le devolvamos la llamada más tarde, simplemente háganos saber la fecha y hora que mejor le convengan.
¡Gracias y esperamos conectarnos con usted pronto!
`,
  },
];
